import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { ProofBar } from './components/ProofBar';
import { Situations } from './components/Situations';
import { Comparison } from './components/Comparison';
import { Gallery } from './components/Gallery';
import { WhatYouGet } from './components/WhatYouGet';
import { Bonuses } from './components/Bonuses';
import { KitBonuses } from './components/KitBonuses';
import { Pricing } from './components/Pricing';
import { KitPricing } from './components/KitPricing';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { useMetaPixel } from './hooks/useMetaPixel';
import { siteMeta } from './data/content';
import { kitFaqs, kitFinalCta, kitHero, kitStats } from './data/kitOffer';
interface AppProps {
  /** "attuale" = 100 maps + 6 bonus. "kitProfessionali" = 100 maps + 6 professional kits (live offer). */
  offerVersion?: 'attuale' | 'kitProfessionali';
  /** Only turn on once real Polish testimonials are loaded in data/content.ts. */
  showTestimonials?: boolean;
}
export function App({
  offerVersion = 'kitProfessionali',
  showTestimonials = false
}: AppProps) {
  useMetaPixel();
  const isKit = offerVersion === 'kitProfessionali';
  useEffect(() => {
    document.documentElement.lang = siteMeta.lang;
    document.title = siteMeta.title;
  }, []);
  return <div className="w-full bg-white text-slate-900 antialiased" data-id="element-0" data-mp="33lx02fiesmyq">
      <main data-id="element-1" data-mp="38lro8basuyg3">
        {isKit ? <Hero subheadline={kitHero.subheadline} description={kitHero.description} data-id="element-2" data-mp="38li619vzxvky" /> : <Hero data-id="element-3" data-mp="3dlw727z6k59h" />}
        {isKit ? <ProofBar stats={kitStats} data-id="element-4" data-mp="3dm5zs3bm0qiv" /> : <ProofBar data-id="element-5" data-mp="nvj1lae5u4n3" />}
        <Situations data-id="element-6" data-mp="nwc23tmizxws" />
        <Comparison data-id="element-7" data-mp="nur948fv0n11" />
        <Gallery data-id="element-8" data-mp="nvasltl5rjh6" />
        <WhatYouGet data-id="element-9" data-mp="nxwupdpa56s0" />
        {isKit ? <KitBonuses data-id="element-10" data-mp="su427axbqqc2" /> : <Bonuses data-id="element-11" data-mp="stkoy7imcq4d" />}
        {isKit ? <KitPricing data-id="element-12" data-mp="ssss6tdacmci" /> : <Pricing data-id="element-13" data-mp="swgkjp6zv2pn" />}
        <Guarantee data-id="element-14" data-mp="3686tkdjumw2" />
        {showTestimonials && <Testimonials data-id="element-15" data-mp="356rh3pi3e8j" />}
        {isKit ? <Faq faqs={kitFaqs} data-id="element-16" data-mp="38b4mqky1kbc" /> : <Faq data-id="element-17" data-mp="3ud1en72ulk9k" />}
        {isKit ? <FinalCta copy={kitFinalCta} data-id="element-18" data-mp="3ubrgkhvzwc2x" /> : <FinalCta data-id="element-19" data-mp="3ucje3y95kjvu" />}
      </main>
      <Footer data-id="element-20" data-mp="d4e6dvbvvgxr" />
    </div>;
}